import { Chapter } from "./content";

export const getNumberedChapterTitle = (chapter: Chapter): string =>
  `${chapter.number}. ${chapter.title}`;
